export default __webpack_public_path__ + "static/media/docketScheduler.6cc6222c.svg";